import { useContext, useEffect, useState } from 'react'
import { PromotedBranchContext } from '../context/context'
import { NavContext } from '../../../context/global_context'
import { getRequest, postRequest } from '../../../services/base'
import {
  TRACER_PREVIEW,
  TRACER_PREVIEW_MGMT,
} from '../../../constants/permission'
import TracerPreviewModal from './Modal'
import { CopyAlt } from '@styled-icons/boxicons-regular/CopyAlt'
import { ProgresSpinner } from '../../common/ProgresSpinner'
import Modal, { ModalBody, ModalHeader } from '../../common/Modal'
import Button from '../../common/Button'
import { useNavigate, useSearchParams } from 'react-router-dom'
import ErrorCard from '../../common/ErrorCard'

const TracerPreview = () => {
  const [state, dispatch] = useContext(PromotedBranchContext)
  const [navState, navDispatch] = useContext(NavContext)
  const [showBranchNotFound, setBranchNotFound] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()

  const navigate = useNavigate()

  useEffect(() => {
    navDispatch({
      type: 'header',
      data: {
        header: 'Tracer Preview',
        sub_header: 'You can see preview of tracer for selected model',
        id: '',
        show_back_btn: true,
        dtc_details: {},
        back_btn_url: '/manage-update-list',
        full_width_container: false,
      },
    })
    validateBranch()
  }, [])

  const validateBranch = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Validating branch with git ...',
        showLoader: true,
      },
      notification: {},
    })
    let res = await getRequest(
      `/api/tracer/preview/validate/?data_version=${searchParams.get('data_version') ? searchParams.get('data_version') : ''}`
    )
    if (res?.data) {
      getCurrentPreview()
    } else {
      navDispatch({
        type: 'notification',
        data: {
          notification_type: 'error',
          msg: 'Branch not available in git, please push selected make model to git.',
        },
      })
      setBranchNotFound(true)
    }
  }

  const getCurrentPreview = async () => {
    navDispatch({
      type: 'loader',
      data: {
        caption: 'Loading Preview Data ...',
        showLoader: true,
      },
      notification: {},
    })

    let res = await getRequest(
      `/api/tracer/preview/preview/?data_version=${searchParams.get('data_version') ? searchParams.get('data_version') : ''}`
    )
    if (res?.status) {
      dispatch({ type: 'set_promoted_branch_data', data: res.data })
      navDispatch({
        type: 'loader',
        data: {},
        notification: {},
      })

      if (
        res?.data?.is_processing ||
        res?.data?.preview_building ||
        res?.data?.preview_deploying
      ) {
        setTimeout(() => {
          getCurrentPreview()
        }, 60000)
      }
    } else {
      navigate('/manage-update-list')
    }
  }

  const startTracerDeployment = async () => {
    if (
      window.confirm(
        `Are you sure want to start tracer for ${state?.data?.tracer_preview?.vehicle}`
      ) === true
    ) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Processing your request ...',
          showLoader: true,
        },
        notification: {},
      })
      let res = await postRequest(`/api/tracer/preview/start/service/`, {
        preview_id: state?.data?.tracer_preview?.preview_id,
      })
      if (res?.data) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Successfully initiated your request',
          },
        })
        getCurrentPreview()
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: 'Something went wrong.',
          },
        })
      }
    }
  }

  const stopTracerDeployment = async () => {
    if (
      window.confirm(
        `Are you sure want to stop tracer for ${state?.data?.tracer_preview?.vehicle}`
      ) === true
    ) {
      navDispatch({
        type: 'loader',
        data: {
          caption: 'Processing your request ...',
          showLoader: true,
        },
        notification: {},
      })
      let res = await postRequest(`/api/tracer/preview/stop/service/`, {
        preview_id: state?.data?.tracer_preview?.preview_id,
      })
      if (res?.data) {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: 'Successfully initiated your request',
          },
        })
        getCurrentPreview()
      } else {
        navDispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: 'Something went wrong.',
          },
        })
      }
    }
  }

  const openTracer = () => {
    if (
      window.confirm(
        `Are you sure want to open tracer for deployed model ${state?.data?.tracer_preview?.vehicle}, Please take credentials from give below`
      ) === true
    ) {
      window.open(state?.data?.tracer_preview?.preview_url, '_blank')
    }
  }

  const copyToClipboard = async (message, textToCopy) => {
    await navigator.clipboard.writeText(textToCopy)

    navDispatch({
      type: 'notification',
      data: {
        notification_type: 'info',
        msg: `${message} copied successfully`,
      },
    })
  }

  return (
    <>
      {showBranchNotFound && (
        <Modal
          onClose={() => {
            navigate('/manage-update-list')
          }}
          show={true}
          size={`w-full`}
        >
          <ModalHeader className={'text-white'}>Tracer Preview</ModalHeader>
          <ModalBody>
            <div className="text-center text-white">
              Branch Not yet pushed to Git, Please cordinate with respective
              person
            </div>
            <div className="text-center">
              <Button
                className={`cursor-pointer btn`}
                text={'Go Back'}
                onClick={() => {
                  navigate('/manage-update-list')
                }}
              />
            </div>
          </ModalBody>
        </Modal>
      )}

      {state?.showTracerPreviewPopup && <TracerPreviewModal />}
      <div className="flex flex-col py-3 space-y-6 w-full text-black" style={{padding: '16px 12%'}}>
        <div className="font-light">
          <div className="w-full flex justify-between text-white items-center ">
            <div className="flex gap-2">
              {!navState?.permissions?.includes(TRACER_PREVIEW_MGMT) &&
                !state?.data?.tracer_preview?.is_running &&
                !state?.data?.preview_building &&
                !state?.data?.preview_deploying && (
                  <ErrorCard
                    title={`Oops!`}
                    sub_title={`Preview is not running so you can't see preview now, and you
                    don't have permission to start new preview.`}
                  />
                )}
            </div>
          </div>

          <div className="flex justify-center items-center p-2 text-white blinking-text text-lg font-medium text-center">
            {(state?.data?.preview_building ||
              state?.data?.preview_deploying) && <ProgresSpinner />}{' '}
            {state?.data?.tracer_preview?.message}
          </div>

          {state?.data?.tracer_preview?.is_running &&
            navState?.permissions?.includes(TRACER_PREVIEW) && (
              <div className="p-2 text-white  text-center">
                <div className="font-medium">
                  User Below Credentials to login into tracer
                </div>
                <div className="flex items-center justify-center gap-2">
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      copyToClipboard(
                        'Username',
                        state?.data?.tracer_credential?.username
                      )
                    }}
                  >
                    <span className="font-bold">User Name : </span>
                    <span>{state?.data?.tracer_credential?.username}</span>{' '}
                    <CopyAlt size={'1rem'} />
                  </div>
                  <div
                    className="cursor-pointer"
                    onClick={() => {
                      copyToClipboard(
                        'Password',
                        state?.data?.tracer_credential?.password
                      )
                    }}
                  >
                    <span className="font-bold">Password : </span>
                    <span>{state?.data?.tracer_credential?.password}</span>{' '}
                    <CopyAlt size={'1rem'} />
                  </div>
                </div>
              </div>
            )}
          <div className="flex w-full flex-wrap">
            {navState?.permissions?.includes(TRACER_PREVIEW_MGMT) &&
              state?.data?.tracer_preview?.status &&
              state?.data?.tracer_preview?.image_name &&
              !state?.data?.tracer_preview?.is_running &&
              !state?.data?.preview_deploying && (
                <div
                  className="w-1/2  p-2 text-white cursor-pointer"
                  onClick={() => {
                    startTracerDeployment()
                  }}
                >
                  <div className="bg-tracer-lt-blue h-56 rounded flex items-center justify-center hover:bg-blue-700">
                    <span className="text-xl">
                      Start Tracer for {state?.data?.tracer_preview?.vehicle}
                    </span>
                  </div>
                </div>
              )}
            {state?.data?.tracer_preview?.is_running &&
              navState?.permissions?.includes(TRACER_PREVIEW) && (
                <div
                  className="w-1/2  p-2 text-white cursor-pointer"
                  onClick={() => openTracer()}
                >
                  <div className="bg-tracer-lt-blue h-56 rounded flex items-center justify-center hover:bg-blue-700">
                    <span className="text-xl">
                      Open Tracer for {state?.data?.tracer_preview?.vehicle}
                    </span>
                  </div>
                </div>
              )}

            {state?.data?.tracer_preview?.status &&
              (state?.data?.preview_deploying ||
                state?.data?.tracer_preview?.is_running) &&
              navState?.permissions?.includes(TRACER_PREVIEW_MGMT) && (
                <div
                  className="w-1/2  p-2 text-white cursor-pointer"
                  onClick={() => stopTracerDeployment()}
                >
                  <div className="bg-tracer-lt-blue h-56 rounded flex items-center justify-center hover:bg-blue-700">
                    <span className="text-xl">
                      Stop Tracer for {state?.data?.tracer_preview?.vehicle}
                    </span>
                  </div>
                </div>
              )}

            {(state?.data?.preview_running ||
              !state?.data?.preview_deploying) &&
              navState?.permissions?.includes(TRACER_PREVIEW_MGMT) && (
                <div className="w-1/2  p-2 text-white cursor-pointer">
                  <div
                    className="bg-tracer-lt-blue h-56 rounded flex items-center justify-center hover:bg-blue-700"
                    onClick={() => {
                      dispatch({
                        type: 'show_hide_tracer_preview',
                        data: true,
                      })
                    }}
                  >
                    <span className="text-xl">
                      Start Tracer Preview for another model
                    </span>
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
    </>
  )
}

export default TracerPreview
